module.exports = __webpack_public_path__ + "static/Gibson-Regular-webfont-fea3689223ee1046a13efbeca3a8a9bc.svg";